<template>
    <section v-if="hasPermissions(['Daily-Assignment Add-Rooms'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="`${title_page} - ${parent.description}`"/>

        <RoomTaskAdvancedSearchVue
            class="mt-5"
            ref="advanced_search"
            :checkeable="true"
            :rest_api="rest_api"
            :rest_api_pagination="pagination_rest_api"
            :table_headers="table_headers"
            @passInitialData="getInitialData($event)"
            :filter_options="filter_options"
            :default_filters="default_filters"
        >
        <template v-slot:overtable>
            <div class="modal__buttons text-center text-md-right mb-3"/>
            <div class="row mb-0 assignments">
                
                <div class="col-12">
                    <div class="row mb-0">
                        <div class="col-md-auto">
                            <div class="templates__legend d-md-flex justify-content-md-between">
                                <div class="mb-2 mb-md-0 templates__legend__item">
                                    Over assigned
                                </div>
                                <div class="templates__legend__item">
                                    Under assigned
                                </div>
                            </div>
                        </div>

                        <div class="col-md-auto">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col" v-for="(item, i) in week_table_headers" :key="i" v-html="item.name"/>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'sun'" type="checkbox" class="custom-control-input" v-model="week_form_data.sunday"/>
                                                    <label :for="'sun'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'mon'" type="checkbox" class="custom-control-input" v-model="week_form_data.monday"/>
                                                    <label :for="'mon'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'tue'" type="checkbox" class="custom-control-input" v-model="week_form_data.tuesday"/>
                                                    <label :for="'tue'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'wed'" type="checkbox" class="custom-control-input" v-model="week_form_data.wednesday"/>
                                                    <label :for="'wed'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'thur'" type="checkbox" class="custom-control-input" v-model="week_form_data.thursday"/>
                                                    <label :for="'thur'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'fri'" type="checkbox" class="custom-control-input" v-model="week_form_data.friday"/>
                                                    <label :for="'fri'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                            <td>
                                                <span class="custom-control custom-checkbox">
                                                    <input :id="'sat'" type="checkbox" class="custom-control-input" v-model="week_form_data.saturday"/>
                                                    <label :for="'sat'" class="custom-control-label ml-2"/>
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-auto">
                            <div class="assignments__statics d-xl-flex justify-content-xl-between align-items-xl-center">
                                <p class="assignments__statics__text">
                                    Current minutes: <strong>{{(rooms_assigned_minutes) ? numberStringFormat(rooms_assigned_minutes) : 0}}</strong>
                                    <button class="modal__buttons__item w-auto button--2" @click="calculateMinutes()">Calc</button>
                                </p>

                                <p class="assignments__statics__text mx-xl-3">
                                    Proposed addittional minutes: <strong>{{proposed_minutes}}</strong>
                                </p>

                                <p class="assignments__statics__text ">
                                    New total minutes: <strong>{{total_new_minutes}}</strong>
                                </p>
                            </div>
                        </div>

                    </div>
                    <div class="modal__buttons text-center text-md-right">
                        <button type="button" class="modal__buttons__item w-auto button--2" v-html="`Refresh`" style="width:300px;" @click="reloaded()"/>
                        <button type="button" class="modal__buttons__item w-auto button--2" v-html="`Add Selected Duties <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" style="width:300px; margin-left:10px;" @click="sendAssignmentRoom(true)"/>
                        <button type="button" class="modal__buttons__item w-auto button--2" v-html="`Add Selected Duties & Continue Search <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" style="width:300px; margin-left:10px;" @click="sendAssignmentRoom()"/>
                    </div>
                </div>
            </div>
        </template>
        </RoomTaskAdvancedSearchVue>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion($event)"
        />
        <WaitingModal/>
    </section>
    <section v-else class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            you do not have permission for this section. contact your system administrator
        </h1>
    </section>
</template>

<script>
import axios                        from    'axios'
import Breadcrumb                   from    '@/components/BreadcrumbComponent/Breadcrumb'
import FormResources                from    './form_resource'
import WaitingModal                 from    '@/components/WaitingModal'
import Methods                      from    './Methods'
import Resources                    from    './resources'
import DeletionModal                from    '@/components/DeletionModal'
import RoomTaskAdvancedSearchVue    from    '@/components/BuildingComponent/Rooms/RoomTaskAdvancedSearch/RoomTaskAdvancedSearch.vue'

/**********styles **********************************************/
import 'vuetify/dist/vuetify.min.css'
import { Notyf }    from    'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})
/***************************************************************/

export default {

    name: 'AssignmentRoomFilter',

    components: {
        Breadcrumb,
        WaitingModal,
        DeletionModal,
        RoomTaskAdvancedSearchVue,
    },

    mixins:[
        Methods,
    ],

    data() {
        return {
            notyf,
            axios,
            user:                   this.get_user(),
            daily_assignment_id:    this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            title_page:             'Assignment',
            rest_api:               `assignment_rooms/${this.$route.params.id}`,
            lite_rest_api:          `assignment_rooms`,
            pagination_rest_api:    `assignment_rooms_pagination`,
            table_headers:          Resources.table_headers,
            week_table_headers:     Resources.week_table_headers,
            breadcrumb:             Resources.breadcrumb,
            select_all:             false,

            /**** Options ************************************/
            boolean_options:    Resources.boolean_options,
            excl_options:       Resources.excl_options,
            freq_options:       Resources.freq_options,
            assigned_options:   Resources.assigned_options,
            filter_options:     Resources.filter_options,
            /*************************************************/

            form_data:          FormResources.form_data,
            week_form_data:     FormResources.week_form_data,
            single_select:      false,
            table_selection:    [],
            search:             '',
            global_index:       0,
            single_object:      {},
            rooms:              [],
            task_frequencies:   [],
            array_options:      {},
            date:               '',
            assigned:           true,
            frequencies:        {},
            rooms_assigned_minutes: 0,
            proposed_minutes: 0,
            total_new_minutes: 0,
            default_filters: [{key: 'show_properly_assigned_rooms', value: true}]
        }
    },

    async mounted()
    {
        if(!this.hasPermissions(['Daily-Assignment Add-Rooms']))
        {
            window.location.href = '/'
        }
    },
}
</script>